module.exports = __webpack_public_path__ + "img/4.2735c246.jpg";